export const goodsTypesTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '分类名称',
    prop: 'name',
    overHidden: true,
  }, {
    label: '是否在商城中显示',
    prop: 'isActive',
    overHidden: true,
    solt: true,
  }, {
    label: '创建人',
    prop: 'creatorName',
    overHidden: true,
  }, {
    label: '创建时间',
    prop: 'insertedTime',
    overHidden: true,
    sortable: true,
  }]
}